import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/sales/item-package/";

export function getItemPackages() {
  return http.get(apiEndpoint);
}

export function getItemPackage(itemPackageID) {
  return http.get(apiEndpoint + itemPackageID);
}

export function saveItemPackage(itemPackage) {
  return http.post(apiEndpoint, itemPackage);
}

export function deleteItemPackage(itemPackageID) {
  return http.delete(apiEndpoint + "item-package/" + itemPackageID);
}
